import TableLayout from "../../../layout/main/TableLayout";
import {Column, Row} from "../../../../styles/CommonStyles";
import CoinRow from "../../../common/common/CoinRow";
import {formatNumber} from "../../../../core/utils/common";
import {FiCopy} from "react-icons/fi";
import {resyncListAttributes} from "../../../../core/constants/headers";
import {useCopyToClipboard} from "../../../../core/hooks/common/useCopyToClipboard";


const ResyncPaymentTable = ({ data, loading }) => {

    const { cs, headers } = resyncListAttributes
    const { copyToClip } = useCopyToClipboard()

    return (
        <TableLayout
            data={{ data: { data } , loading }}
            cs={cs}
            headers={headers}
            hasPagination={false}
        >
            {data.map((item, idx) => {

                return (
                    <Row cs={cs} key={item.txId}>
                        <Column>
                            {idx + 1}
                        </Column>
                        <Column>
                            <CoinRow coin={{currency: item.currency}}/>
                        </Column>
                        <Column>
                            <span>{formatNumber(item.amount, { type: item.currency })}</span>
                        </Column>
                        <Column>
                            <div className={'flex items-center gap-2'}>
                                <span className={'max-w-[200px] truncate'}>{item.txId}</span>
                                <div className={'cursor-pointer'} onClick={() => copyToClip(item.txId)}>
                                    <FiCopy size={20} />
                                </div>
                            </div>
                        </Column>
                    </Row>
                )
            })
            }
        </TableLayout>
    )
}

export default ResyncPaymentTable
